/**
 * Role-Based Redirect Component
 * Redirects users to appropriate dashboard based on their role
 */
import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { getCurrentUser } from '../utils/rbac';

const RoleBasedRedirect: React.FC = () => {
  const currentUser = getCurrentUser();
  
  useEffect(() => {
    // If no user, will redirect to login via ProtectedRoute
    if (!currentUser) {
      return;
    }
  }, [currentUser]);

  // If no user, redirect to login (ProtectedRoute will handle this)
  if (!currentUser) {
    return <Navigate to="/user/login" replace />;
  }

  // Super Admin goes to Super Admin dashboard
  if (currentUser.roleName?.toLowerCase() === 'super admin') {
    return <Navigate to="/superadmin" replace />;
  }

  // Admin goes to Admin Portal dashboard
  if (currentUser.roleName?.toLowerCase() === 'admin') {
    return <Navigate to="/admin-portal/dashboard" replace />;
  }

  // All other users go to main dashboard
  return <Navigate to="/dashboard" replace />;
};

export default RoleBasedRedirect;
